import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  props: {
    entity: String,
    page: {
      type: [Number, String],
      default: 1,
    },
    value: [Array, Object],
    initialConstraint: {
      type: Object,
      default() {
        return {};
      },
    },
    initialCriteria: {
      type: Object,
      default() {
        return {};
      },
    },
    timeout: {
      type: Number,
      default: 500,
    },
    minLength: {
      type: Number,
      default: 3,
    },
    searchConfig: {
      type: Object,
    },
    addSelectCheckbox: {
      type: Boolean,
      default: false,
    },
    withProgressBar: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.initConstraintAndCriteria();

    console.log({ searchConfig: this.searchConfig });
  },
  data() {
    return {
      items: [],
      loading: false,
      params: {
        search: '',
        page: this.page,
        constraint: {},
        criteria: {},
      },
      search: '',
      constraint: {},
      criteria: {},
      constraintOperators: {},
      constraintConfig: {},
      criteriaConfig: {},
      defaultFieldClass: null,
    };
  },
  computed: {
    hasConstraintFields() {
      return this.constraintConfig.hasOwnProperty('fields');
    },
    hasCriteriaFields() {
      return this.criteriaConfig.hasOwnProperty('fields');
    },
  },
  methods: {
    initConstraintAndCriteria() {
      if (!!this.searchConfig && this.searchConfig.hasOwnProperty('constraint')) {
        this.constraintConfig = this.searchConfig.constraint;
        if (this.hasConstraintFields) {
          this.constraintConfig.fields.forEach(field => {
            if (field.hasOwnProperty('value')) {
              this.$set(this.constraint, field.name, field.value);
            } else {
              this.$set(this.constraint, field.name, []);
            }
            this.$set(
              this.constraintOperators,
              field.name,
              field.operator ? ':' + field.operator : ':like',
            );
          });
        }
      }

      if (!!this.searchConfig && this.searchConfig.hasOwnProperty('criteria')) {
        this.criteriaConfig = this.searchConfig.criteria;
        if (this.hasCriteriaFields) {
          this.criteriaConfig.fields.forEach(field => {
            if (field.hasOwnProperty('value')) {
              this.$set(this.criteria, field.name, field.value);
            } else {
              this.$set(this.criteria, field.name, []);
            }
          });
        }
      }

      if (this.initialConstraint) {
        for (const field in this.initialConstraint) {
          if (this.initialConstraint.hasOwnProperty(field)) {
            const value = this.initialConstraint[field];
            this.$set(this.constraint, field, value);

            // if(this.constraint.hasOwnProperty(field)) {
            //     this.constraint[field].push(value);
            // } else {
            //     this.$set(this.constraint, field, []);
            //     this.$set(this.constraintOperators, field, ':like');

            // }
          }
        }
      }

      if (
        !!this.searchConfig &&
        this.searchConfig.hasOwnProperty('criteria') &&
        this.initialCriteria
      ) {
        for (const field in this.initialCriteria) {
          if (this.initialCriteria.hasOwnProperty(field)) {
            const value = this.initialCriteria[field];
            this.$set(this.criteria, field, value);
          }
        }
      }

      this.getEntities();

      // this.$emit('initialContraintReady');

      console.log({ initConstraint: this.constraint });
    },
    getEntities() {
      this.loading = true;
      if (this.params.page === 1) {
        this.$emit('loading');
      }
      let config = {};
      config.params = this.params;
      apiCtrl.get('/' + this.entity, config).then(res => {
        console.log(res);
        if (this.addSelectCheckbox) {
          this.items = res.data.data.map(item => {
            this.$set(item, 'selected', false);
            return item;
          });
        } else {
          this.items = res.data.data;
        }
        this.loading = false;
        this.$emit('stopLoading');
        this.$emit('input', this.items);
        if (res.data.hasOwnProperty('meta')) {
          // console.log({META: res.data.meta});
          // if(this.page > res.data.meta.lastPage)
          this.$emit('meta', res.data.meta);
        }
      });
    },
    searchIfStop: function(val) {
      if (val === this.search) {
        this.page = 1;
        this.getEntities();
      }
    },
    searchIfStopConstraint: function(val) {
      if (val === this.constraint) {
        this.page = 1;
        this.getEntities();
      }
    },

    searchIfStopCriteria: function(val) {
      if (val === this.criteria) {
        this.page = 1;
        this.getEntities();
      }
    },
    getFieldClass(field) {
      return field['class'] ? field['class'] : this.defaultFieldClass ? this.defaultFieldClass : '';
    },
    getFieldAttrs(field) {
      return field['fieldAttrs'] ? field['fieldAttrs'] : {};
    },
  },
  watch: {
    search: function(val, oldVal) {
      this.params.search = val;
      if (
        !this.loading &&
        !!val &&
        (val.length > this.minLength || (!!oldVal && oldVal.length > val.length))
      ) {
        // console.log(val);
        const component = this;
        setTimeout(() => {
          component.searchIfStop(val);
        }, component.timeout);
      }
    },
    constraint: {
      handler: function(newValue) {
        console.log(newValue);
        for (const field in newValue) {
          if (newValue.hasOwnProperty(field)) {
            const val = newValue[field];

            console.log(val);

            if (Array.isArray(val) && val.length > 0) {
              this.params.constraint[field] = val.join(';') + this.constraintOperators[field];
            } else {
              if (0 === val.length) {
                this.params.constraint[field] = [];
              } else {
                this.params.constraint[field] = val + this.constraintOperators[field];
              }
            }
          }
        }
        // if (!this.loading) {

        // console.log(val);
        const component = this;
        setTimeout(() => {
          component.searchIfStopConstraint(newValue);
        }, component.timeout);

        // }
        console.log({ constranintChange: this.params });
      },
      deep: true,
    },

    criteria: {
      handler: function(newValue) {
        console.log(newValue);
        for (const field in newValue) {
          if (newValue.hasOwnProperty(field)) {
            const val = newValue[field];

            console.log(val);
            this.$set(this.params.criteria, field, val);

            // if (Array.isArray(val) && val.length > 0) {
            //   this.params.criteria[field] = val;
            // } else {
            //   if (0 === val.length) {
            //     this.params.criteria[field] = [];
            //   } else {
            //     this.params.criteria[field] = val;
            //   }
            // }
          }
        }
        // if (!this.loading) {

        // console.log(val);
        const component = this;
        setTimeout(() => {
          component.searchIfStopCriteria(newValue);
        }, component.timeout);

        // }
        console.log({ criteriaChange: this.params });
      },
      deep: true,
    },

    page: function(val, oldVal) {
      this.params.page = val;
      // console.log(val);

      this.getEntities();
    },

    searchConfig: function(val, oldVal) {
      this.constraintConfig = val.constraint;
      console.log({ Constraint: this.constraintConfig });
    },
  },
};
